export const justificationOptions = [
    {
        key: 1,
        text: 'Adjust soil PH',
        value: 'Adjust soil PH'
    },
    {
        key: 2,
        text: 'Tree health',
        value: 'Tree health'
    },
    {
        key: 3,
        text: 'Nutrient imbalance',
        value: 'Nutrient imbalance'
    }
];
